import { render, staticRenderFns } from "./f2g-subtitle.vue?vue&type=template&id=70077cc8&scoped=true"
import script from "./f2g-subtitle.vue?vue&type=script&lang=js"
export * from "./f2g-subtitle.vue?vue&type=script&lang=js"
import style0 from "./f2g-subtitle.vue?vue&type=style&index=0&id=70077cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70077cc8",
  null
  
)

export default component.exports